var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"login"}},[_c('div',{staticClass:"login__wrapper"},[_c('div',[_c('img',{staticClass:"login_wrapper__logo mb-4",attrs:{"src":require("../../../assets/images/logo-e.png")}}),_c('reset')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }